import { useEffect, useState } from "react";
import { api } from "../api/client.js";
export function useSbaiFreeze() {
  const [status, setStatus] = useState<Awaited<ReturnType<typeof api.sbaiStatus>> | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    let pending = false;
    const refresh = async () => {
      if (pending || !active) return;
      pending = true;
      try {
        const value = await api.sbaiStatus();
        if (active) {
          setStatus(value);
          setFailed(false);
        }
      } catch {
        if (active) {
          setStatus(null);
          setFailed(true);
        }
      } finally {
        pending = false;
      }
    };
    void refresh();
    const timer = window.setInterval(() => {
      void refresh();
    }, 15000);
    const onFocus = () => {
      void refresh();
    };
    window.addEventListener("focus", onFocus);
    return () => {
      active = false;
      window.clearInterval(timer);
      window.removeEventListener("focus", onFocus);
    };
  }, []);
  return { status, canWrite: status?.locked === false && !failed, failed };
}
export function SbaiFreezeNotice({ freeze }: { freeze: ReturnType<typeof useSbaiFreeze> }) {
  if (freeze.status?.locked)
    return (
      <div className="banner banner-quiet" role="status">
        SBAI candidate {freeze.status.candidateId}: configuration is frozen. Profile and policy
        changes require a new candidate.{" "}
        <span className="mono-12">{freeze.status.configurationSha256}</span>
      </div>
    );
  if (!freeze.status)
    return (
      <div className="banner banner-quiet" role="status">
        {freeze.failed
          ? "Cannot verify configuration lock. Changes are unavailable."
          : "Checking configuration lock…"}
      </div>
    );
  return null;
}
